export default __webpack_public_path__ + "static/media/CNo.66-3.53d3b537.jpg";